// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"9a82734d","488":"cc46d850","823":"df39a88c"}[chunkId] + ".chunk.js";
};